// src/DropoffDateTime.js
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deDE } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

export default function DropoffDateTime() {
  const [dropoffDateTime, setDropoffDateTime] = useState(null);
  const [minDateTime, setMinDateTime] = useState(null);
  const [isPickerOpen, setPickerOpen] = useState(false); // ✅ Added missing state

  // Read initial value from HTML attributes
  useEffect(() => {
    const root = document.getElementById('dropoff-root');
    if (root) {
      const dateStr = root.dataset.date;
      const timeStr = root.dataset.time;
      if (dateStr && timeStr) {
        const combined = dayjs(`${dateStr} ${timeStr}`, 'DD.MM.YYYY HH:mm');
        setDropoffDateTime(combined.isValid() ? combined : null);
      }
    }
  }, []);

  // Sync with pickup
  useEffect(() => {
    const interval = setInterval(() => {
      const pickup = window.__pickupDateTime__;
      if (pickup) {
        const pickupDay = pickup.startOf('day');
        if (!minDateTime || !pickupDay.isSame(minDateTime)) {
          setMinDateTime(pickupDay);
        }

        // ❌ Don't auto-set dropoff anymore

        // ✅ Only clear dropoff if it is before pickup
      }
    }, 300);

    return () => clearInterval(interval);
  }, [dropoffDateTime, minDateTime]);

  useEffect(() => {
    const dropoffInput = document.getElementById('dropoff');
    const dropoffTimeInput = document.getElementById('dropoff_time');
    const pickupDropoffInput = document.getElementById('pickup_dropoff');

    if (dropoffDateTime) {
      const date = dropoffDateTime.format('DD.MM.YYYY');
      const time = dropoffDateTime.format('HH:mm');

      if (dropoffInput) dropoffInput.value = date;
      if (dropoffTimeInput) dropoffTimeInput.value = time;

      const pickup = document.getElementById('pickup').value;
      if (pickupDropoffInput) pickupDropoffInput.value = `${pickup} to ${date}`;
    } else {
      if (dropoffInput) dropoffInput.value = '';
      if (dropoffTimeInput) dropoffTimeInput.value = '';
      if (pickupDropoffInput) pickupDropoffInput.value = '';
    }
  }, [dropoffDateTime]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="de"
      localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box sx={{ width: '100%' }}>
        <DateTimePicker
          value={dropoffDateTime}
          onChange={setDropoffDateTime}
          minDateTime={minDateTime}
          ampm={false}
          format="DD.MM.YYYY HH:mm"
          open={isPickerOpen}
          onOpen={() => setPickerOpen(true)}
          onClose={() => setPickerOpen(false)}
          slotProps={{
            textField: {
              placeholder: 'TT.MM.JJJJ hh:mm',
              fullWidth: true,
              variant: 'outlined',
              inputProps: { readOnly: false },
              onBlur: (e) => {
                const inputVal = e.target.value;
                const parsed = dayjs(inputVal, 'DD.MM.YYYY HH:mm', true);
                if (parsed.isValid()) {
                  setDropoffDateTime(parsed);

                  // 🔁 Immediately update hidden inputs
                  const date = parsed.format('DD.MM.YYYY');
                  const time = parsed.format('HH:mm');
                  document.getElementById('dropoff').value = date;
                  document.getElementById('dropoff_time').value = time;

                  const pickup = document.getElementById('pickup').value;
                  document.getElementById('pickup_dropoff').value = `${pickup} to ${date}`;
                }
              }
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
